import type { ImportRowIssue, ImportSession, ImportTarget } from '@/types/import';

export const DEMO_IMPORT_TARGET: ImportTarget = {
  companyId: 1,
  companyName: 'Demo Company',
  companyGroupId: 1,
  companyGroupName: 'DemoFinancials',
};

// Demo sessions stay in finished states so the single-active-import gate remains open and polling stays off.
export const DEMO_IMPORT_SESSIONS: ImportSession[] = [
  {
    publicId: '00000000-0000-0000-0000-000000000001',
    importType: 'customerContacts',
    status: 'Committed',
    fileName: 'customer-contacts.xlsx',
    fileSizeBytes: 48_128,
    totalRows: 412,
    errorCount: 0,
    warningCount: 3,
    insertedCount: 386,
    updatedCount: 24,
    skippedDuplicateCount: 2,
    failureReason: null,
    createdByUserName: 'Demo Administrator',
    createdAt: '2026-01-12T09:14:00Z',
    completedAt: '2026-01-12T09:15:22Z',
  },
  {
    publicId: '00000000-0000-0000-0000-000000000002',
    importType: 'customerCollectionSettings',
    status: 'Rejected',
    fileName: 'collection-settings-january.xlsx',
    fileSizeBytes: 21_504,
    totalRows: 128,
    errorCount: 14,
    warningCount: 5,
    insertedCount: 0,
    updatedCount: 0,
    skippedDuplicateCount: 0,
    failureReason: 'Validation found errors in 14 rows. Correct the workbook and upload it again.',
    createdByUserName: 'Demo Administrator',
    createdAt: '2026-01-13T11:02:00Z',
    completedAt: '2026-01-13T11:02:47Z',
  },
];

export const DEMO_IMPORT_ISSUES: ImportRowIssue[] = [
  {
    rowNumber: 4,
    severity: 'Error',
    fieldName: 'Customer account',
    fieldValue: 'ACC-99120',
    message: 'No customer was found with this account reference.',
  },
  {
    rowNumber: 7,
    severity: 'Error',
    fieldName: 'Email',
    fieldValue: 'jane.doe@',
    message: 'The email address is not valid.',
  },
  {
    rowNumber: 11,
    severity: 'Error',
    fieldName: 'Credit limit',
    fieldValue: '-2500',
    message: 'The credit limit cannot be negative.',
  },
  {
    rowNumber: 15,
    severity: 'Warning',
    fieldName: 'Phone',
    fieldValue: '0161 000 0000',
    message: 'The phone number is missing a country code and was imported as entered.',
  },
  {
    rowNumber: 18,
    severity: 'Warning',
    fieldName: 'Contact role',
    fieldValue: 'Acounts Payable',
    message: 'The role was not recognised and has been stored as a free-text role.',
  },
  {
    rowNumber: 23,
    severity: 'Warning',
    fieldName: null,
    fieldValue: null,
    message: 'The row duplicates an earlier row in the workbook and was skipped.',
  },
];
